const router =[
    {
        path: '/offer',
        meta: {
            title: '',
        },
        component: (resolve) => require(['../views/offer/offer'], resolve)
    },
  ];
  
  export default router;


// WEBPACK FOOTER //
// ./src/router/offer.js